import { useState } from "react";

export interface Loading {
  loaded: () => boolean;
  setLoaded: () => void;
}

enum LoadingState {
  Cold = "COLD",
  Loaded = "LOADED",
}

export const useLoading = (): Loading => {
  const [state, setState] = useState<LoadingState>(LoadingState.Cold);

  const loading = {
    loaded: () => {
      return state !== LoadingState.Cold;
    },
    setLoaded: () => {
      setState(LoadingState.Loaded);
    },
  };

  return loading;
};
